/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Button,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import GroupsIcon from "@mui/icons-material/Groups";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SetSPHealthScore from "../../Modals/setSPHealthScore";
import ViewSPHealthScores from "../../Modals/viewSPHealthScores";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

/* ================= TYPES ================= */

interface ServiceProvider {
    id: string;
    name: string;
    email: string;
    phone: string;
    type: string;
    status: string;
    health: number;
    change: string | null;
}

interface HealthBarProps {
    value: number;
    change?: string | null;
}

/* ================= COMPONENT ================= */

const SPHealthScore: React.FC = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState<string>("");

    const spColumns: string[] = [
        "Service Provider",
        "Contact",
        "Service Type",
        "Status",
        "Health Score",
        "Severity",
        "Actions",
    ];

    const [spData] = useState<ServiceProvider[]>([
        {
            id: "SP-001",
            name: "PixelCraft Studios",
            email: "hello@pixelcraft.ae",
            phone: "+971501112222",
            type: "Photography",
            status: "Active",
            health: 94.2,
            change: "+2.4",
        },
        {
            id: "SP-002",
            name: "DesignSphere",
            email: "contact@designsphere.ae",
            phone: "+971503334444",
            type: "UI Design",
            status: "Active",
            health: 81.6,
            change: "-1.1",
        },
        {
            id: "SP-003",
            name: "MotionHive",
            email: "projects@motionhive.ae",
            phone: "+971505556666",
            type: "Video Editing",
            status: "At Risk",
            health: 72.4,
            change: "-5.5",
        },
        {
            id: "SP-004",
            name: "CleanPros",
            email: "ops@cleanpros.ae",
            phone: "+971507778888",
            type: "Cleaning",
            status: "Critical",
            health: 45.0,
            change: "-12.5",
        },
    ]);

    /* ================= HELPERS ================= */

    const HealthBar: React.FC<HealthBarProps> = ({ value, change }) => {
        const color =
            value >= 85 ? "#22c55e" : value >= 70 ? "#f59e0b" : "#ef4444";

        return (
            <div className="health_bar">
                <span className="bar">
                    <span style={{ background: color, width: `${value}%` }} />
                </span>

                <small>
                    {value}
                    {change && (
                        <>
                            <br />
                            <ins
                                className={
                                    change.startsWith("-")
                                        ? "down"
                                        : "up"
                                }
                            >
                                {change} <i>{change.startsWith("-") ? "▼" : "▲"}</i>
                            </ins>
                        </>
                    )}
                </small>
            </div>
        );
    };

    const getSeverity = (health: number): "Info" | "Warning" | "Critical" => {
        if (health >= 85) return "Info";
        if (health >= 70) return "Warning";
        return "Critical";
    };

    /* ================= MODALS ================= */

    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openModal1, setOpenModal1] = useState<boolean>(false);
    const [selectedProvider, setSelectedProvider] = useState<any>(null);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleViewDetails = (provider: ServiceProvider) => {
        setSelectedProvider(provider);
        setOpenModal1(true);
    };

    /* ================= JSX ================= */

    return (
        <>
            <div className="main_title">
                <h1>Service Provider Health Scores</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Service Provider Health Scores
                </p>
            </div>

            <div className="stats_boxes gap_m">
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            1,301
                            <p>Total Service Providers</p>
                        </h2>
                        <figure className="blue">
                            <GroupsIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            82.4
                            <p>Avg Health Scores</p>
                        </h2>
                        <figure className="sucess">
                            <DescriptionOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            42
                            <p>At Risk</p>
                        </h2>
                        <figure className="warning">
                            <WarningAmberRoundedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            8
                            <p>Critical</p>
                        </h2>
                        <figure className="danger2">
                            <WarningAmberRoundedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>
            <div className="table_flex mt_20">
                <div className="lt">

                    <div className="cards ">
                        <div className="table_header">
                            <div className="left_s">
                                <Box className="search_box">
                                    <SearchBar
                                        searchTerm={searchTerm}
                                        setDebouncedSearchTerm={setSearchTerm}
                                        placeholder="Search providers..."
                                    />
                                </Box>
                            </div>

                            <div className="right_s form">
                                <select>
                                    <option value="all">All Severities</option>
                                    <option value="info">Info</option>
                                    <option value="warning">Warning</option>
                                    <option value="critical">Critical</option>
                                </select>

                                <Button
                                    className="btn btn_primary"
                                    onClick={() => setOpenModal(true)}
                                >
                                    Manage Score Weightage
                                </Button>
                            </div>
                        </div>

                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {spColumns.map((col) => (
                                            <TableCell key={col}>{col}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {spData.map((provider) => (
                                        <TableRow key={provider.id} hover>
                                            <TableCell>
                                                <b>{provider.name}</b>
                                                <br />
                                                <small>{provider.id}</small>
                                            </TableCell>

                                            <TableCell>
                                                {provider.email}
                                                <br />
                                                <small>{provider.phone}</small>
                                            </TableCell>

                                            <TableCell>{provider.type}</TableCell>
                                            <TableCell>{provider.status}</TableCell>

                                            <TableCell>
                                                <div className="health_wrap">
                                                    <HealthBar
                                                        value={provider.health}
                                                        change={provider.change}
                                                    />
                                                </div>
                                            </TableCell>

                                            <TableCell>
                                                <span
                                                    className={`status_chip ${getSeverity(provider.health).toLowerCase()}`}
                                                >
                                                    {getSeverity(provider.health)}
                                                </span>
                                            </TableCell>

                                            <TableCell>
                                                <div className="table_actions v2">
                                                    <IconButton onClick={() => handleViewDetails(provider)}>
                                                        <img src="/static/images/eye_icon.svg" alt="Actions" />
                                                    </IconButton>
                                                    <IconButton onClick={handleOpen}>
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                    <Menu
                                                        anchorEl={anchorEl}
                                                        open={Boolean(anchorEl)}
                                                        onClose={handleClose}
                                                        anchorOrigin={{
                                                            vertical: "bottom",
                                                            horizontal: "right",
                                                        }}
                                                        transformOrigin={{
                                                            vertical: "top",
                                                            horizontal: "right",
                                                        }}
                                                        className="table_menu"
                                                    >
                                                        <MenuItem onClick={handleClose}>
                                                            <ListItemIcon>
                                                                <EmailOutlinedIcon fontSize="small" />
                                                            </ListItemIcon>
                                                            Send Email
                                                        </MenuItem>

                                                        <MenuItem onClick={handleClose}>
                                                            <ListItemIcon>
                                                                <FlagOutlinedIcon fontSize="small" />
                                                            </ListItemIcon>
                                                            Flag for Review
                                                        </MenuItem>

                                                        <MenuItem onClick={handleClose}>
                                                            <ListItemIcon>
                                                                <BlockOutlinedIcon fontSize="small" />
                                                            </ListItemIcon>
                                                            Suspend Provider
                                                        </MenuItem>

                                                    </Menu>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Insights</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                </div>
            </div>


            <SetSPHealthScore open={openModal} onClose={() => setOpenModal(false)} setOpen={setOpenModal} />
            <ViewSPHealthScores open={openModal1} onClose={() => setOpenModal1(false)} setOpen={setOpenModal1} provider={selectedProvider} />
        </>
    );
};

export default SPHealthScore;
